import axios from 'axios'

const baseUrl = window.location.hostname.indexOf('dev') > -1 ||
  window.location.hostname.indexOf('localhost') > -1 ?
  "https://apidev.daftareshoma.com" :
  "https://api.daftareshoma.com"

const clientError = "ورودی ها به صورت درست به سرور ارسال نشده است"
const serverError = "سرور در اجرای درخواست شما با مشکل مواجه شده است"
const notExeAPI = " در خواست از سرور با مشکل مواجه شده است"
const NotCallApi = " درخواست شما برای سرور ارسال نشد"

axios.defaults.headers.Accept = 'application/json'
axios.defaults.baseURL = baseUrl
// axios.defaults.headers.common['Accept-Language'] = localStorage.getItem('i18nextLng')


axios.interceptors.request.use(
  (config) => {
    const adminAccesssToken = localStorage.getItem('adminAccesssToken')
    if (adminAccesssToken) {
      config.headers.Authorization = `Bearer ${adminAccesssToken}`
    }
    return config
  },
  (err) =>
    Promise.reject(err),
)
axios.defaults.withCredentials = true
axios.interceptors.response.use(
  response => response,
  (error) => {
    if ((error.response?.status === 400 || error.response?.status === 404)) {
      if (error.response?.data) {
        return Promise.reject(error.response?.data)
      }
      else {
        return Promise.reject(clientError)
      }
    }
    else if ((error.response?.status === 500)) {
      return Promise.reject(serverError)
    }
    else {
      return Promise.reject(NotCallApi)
    }
  },
  
)

export default axios

